import { navigateToTeamsApp } from '@atlaskit/teams-app-config/navigation';

import { COMPANY_HUB } from '@confluence/named-routes';
import { useSessionData } from '@confluence/session-data';
import { isTeamsAppEnabled } from '@confluence/teams-app-config';

export const useFallbackUrls = (): Record<string, string> => {
	const { cloudId, orgId } = useSessionData();
	const { href } = navigateToTeamsApp({
		type: 'LANDING',
		cloudId,
		orgId,
		userHasNav4Enabled: true,
	});
	return {
		companyHubShortcut: COMPANY_HUB.toUrl(),
		teamsShortcut: isTeamsAppEnabled() ? href : '',
	};
};
